<template>
  <main id="subPage">
    <!-- 카테고리 -->
    <section id="category">
      <h2>정보마당</h2>
      <ul class="breadCrumb">
        <li class="home"></li>
        <li class="web">
          <p class="pageTxt">정보마당</p>
          <ul class="depth">
            <li><router-link to="/map" title="공영주차장">공영주차장</router-link></li>
            <li><router-link to="/unpaidinfo" title="주차요금정산">주차요금정산</router-link></li>
            <li><router-link to="/periodinfo" title="주차서비스">주차서비스</router-link></li>
            <li><router-link to="/noticelist" title="정보마당">정보마당</router-link></li>
          </ul>
        </li>
        <li>
          <p class="pageTxt">묻고 답하기</p>
          <ul class="depth">
            <li><router-link to="/noticelist" title="공지사항">공지사항</router-link></li>
            <li><router-link to="/faqview" title="자주묻는질문">자주묻는질문</router-link></li>
            <li><router-link to="/qnalist" title="묻고 답하기">묻고 답하기</router-link></li>
          </ul>
        </li>
      </ul>
    </section>

    <!-- 컨텐츠 영역 -->
    <section id="content">
      <div class="inner">
        <h3 class="pageTitle">묻고 답하기</h3>
        <article>
          <div class="table vertical-table notice">
            <table>
              <caption>
                묻고 답하기 리스트 테이블
              </caption>
              <colgroup>
                <col style="width: 10%" />
                <col style="width: auto" />
                <col style="width: 15%" />
                <col style="width: 15%" />
              </colgroup>
              <thead>
                <tr>
                  <th scope="col">답변상태</th>
                  <th scope="col">제목</th>
                  <th scope="col">작성자</th>
                  <th scope="col">등록일</th>
                </tr>
              </thead>
              <tbody class="nodate" v-if="nodata">
                <tr class="nodate">
                  <td colspan="9">조회된 데이터가 없습니다.</td>
                </tr>
              </tbody>
              <tbody v-for="(item, index) in listData" :key="index" @click="getInquiryInfo(item)">
                <tr>
                  <td>{{ item.answer ? '답변완료' : '답변대기' }}</td>
                  <td>
                    <p class="title">{{ item.title }}</p>
                  </td>
                  <td>{{ item.writer }}</td>
                  <td>{{ item.createdate }}</td>
                </tr>
                <tr v-if="item.nondisclosure && item.answer">
                  <td></td>
                  <td colspan="3">
                    <p class="title secret">비밀글입니다.</p>
                  </td>
                </tr>
                <tr v-else-if="!item.nondisclosure && item.answer">
                  <td></td>
                  <td colspan="3">
                    <p class="title">답변</p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="btnArea txt-right mt20">
            <button type="button" class="btn border" @click="$router.push('qnaenrollment')">글쓰기</button>
          </div>

          <!-- 페이지네이션 -->
          <v-pagination v-model="curPageNum" :length="numOfPages" @input="findInquiry"></v-pagination>
        </article>
      </div>
    </section>

    <!-- 알럿 -->
    <alert-notmatch v-show="showModalMsgFailure">
      <template #content>
        <p>{{ msg1 }}</p>
        <article class="btnArea">
          <button class="btn blue" @click="CancleBtn">확인</button>
        </article>
      </template>
      <template #button>
        <button class="btn closeBtn" @click="CancleBtn"><span class="hidden">닫기</span></button>
      </template>
    </alert-notmatch>

    <!-- 패스워드 변경 -->
    <popup v-show="showModal">
      <template #info> 비밀번호 입력 </template>
      <template #content>
        <article class="paragraph">
          <p>비밀번호를 입력 해 주세요.</p>
        </article>
        <article>
          <div class="table pop-table">
            <table>
              <caption>
                비밀번호 입력 테이블
              </caption>
              <colgroup>
                <col style="width: 20%; min-width: 80px" />
                <col style="width: 80%" />
              </colgroup>
              <tbody>
                <tr>
                  <th scope="row">비밀번호</th>
                  <td>
                    <input type="password" title="비밀번호 입력" v-model="password" />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </article>
        <article class="btnArea">
          <button class="btn blue" @click="chkPw">확인</button>
        </article>
        <!-- <article>
					<div class="not-match">
						<div class="skyBox">
							<p>비밀번호가 일치하지 않습니다.</p>
							<p>다시 한번 정확히 입력해 주세요.</p>
						</div>
					</div>
				</article> -->
      </template>
      <template #button>
        <button class="btn closeBtn" @click="CancleBtn"><span class="hidden">닫기</span></button>
      </template>
    </popup>
  </main>
</template>

<script>
import axios from '../../../util/axios';
import pagination from '../../../util/pagination';
import AlertNotmatch from '../../../components/Alert02.vue';
import Popup from '../../../components/PopupType1.vue';
import _ from 'lodash';

export default {
  data() {
    return {
      showModalMsgFailure: false,
      showModal: false,

      msg1: '비밀번호가 맞지 않습니다.',
      listData: [],
      listCnt: 0,
      nodata: true,
      curPageNum: 1,
      dataPerPage: 10,

      applyId: '',
      inquiry: {},
      password: '',
    };
  },

  components: {
    AlertNotmatch,
    Popup,
  },

  mounted() {
    this.applyId = this.$store.state.empNo;
    this.findInquiry();
  },

  methods: {
    CancleBtn() {
      this.showModalMsgFailure = false;
      this.showModal = false;
    },

    async findInquiry() {
      const res = await axios('get', '/api/inquiry/list', {
        recordCountPerPage: this.dataPerPage,
        firstIndex: (this.curPageNum - 1) * this.dataPerPage,
      });
      if (res.data.boardList != undefined) {
        this.listCnt = res.data.boardTotalCount;
        this.listData = pagination(res.data.boardList, this.listCnt, this.curPageNum, this.dataPerPage);
        this.nodata = false;
      }
      this.nodata = true;
    },

    async getInquiryInfo(inquiry) {
      this.inquiry = inquiry;
      if (this.$store.state.authorCode === 'ROLE_ADMIN') {
        this.$router.push({
          path: 'qnaanswerenrollment',
          query: { inquiryId: this.inquiry.inquiryId },
        });
        return;
      } else if (this.inquiry.nondisclosure) {
        this.showModal = true;
        return;
      } else if (!this.inquiry.nondisclosure) {
        this.$router.push({
          path: 'qnaView',
          query: { inquiryId: this.inquiry.inquiryId, viewAuthChk: true },
        });
      }
    },

    async chkPw() {
      const apiParams = new FormData();
      apiParams.append('inquiryId', this.inquiry.inquiryId);
      apiParams.append('password', this.password);
      const res = await axios('post', '/api/inquiry/pwChk', apiParams);
      if (!res.data.result) {
        this.msg1 = '비밀번호가 맞지 않습니다.';
        this.showModalMsgFailure = true;
        this.showModal = false;
        this.password = '';
        return;
      } else {
        await this.$router.push({
          path: 'qnaView',
          query: { inquiryId: this.inquiry.inquiryId, viewAuthChk: true },
        });
      }
    },

    async view() {
      await this.$router.push({
        path: 'qnaView',
        query: { inquiryId: this.inquiry.inquiryId, viewAuthChk: true },
      });
    },
  },

  computed: {
    numOfPages() {
      return Math.ceil(this.listCnt / this.dataPerPage);
    },
  },
};
</script>
